import { Icon } from "../icons";

interface DetailRowProps {
  iconName: string;
  label: string;
  value: string;
  mono?: boolean;
}

export function DetailRow({ iconName, label, value, mono = false }: DetailRowProps) {
  return (
    <div className="d-flex align-items-start gap-2 py-2 border-bottom">
      <Icon
        iconName={iconName}
        className="text-muted flex-shrink-0 mt-1"
        style={{ width: 14 }}
      />
      <div>
        <div
          className="text-uppercase fw-semibold mb-1 text-muted"
          style={{ fontSize: "0.6875rem", letterSpacing: "0.08em" }}
        >
          {label}
        </div>
        <div className={`small ${mono ? "font-monospace" : ""}`}>{value}</div>
      </div>
    </div>
  );
}
